import ReactDOM from "react-dom";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import "./Modal.css";
import { Fragment, useContext, useEffect, useState } from "react";
import AuthContext from "../../store/auth-context";
import BackdropContext from "../../store/backdrop-context";
import { SendPostRequest, SendPutRequest } from "../../actions/Actions";
import { isNull } from "../../utils/Utils";
import { baseUrl } from "../../Config";
import SubscriptionStatusEnum from "../../enum/SubscriptionStatusEnum";
import PaymentTypeEnum from "../../enum/PaymentTypeEnum";

const ModalContent = (props) => {

  const customers = props.customers;

  const authContext = useContext(AuthContext);
  const backdropContext = useContext(BackdropContext);

  const [customer, setCustomer] = useState(null);
  const [emailSubject, setEmailSubject] = useState(null);
  const [emailTracingUrl, setEmailTrackingUrl] = useState(null);

  const handleClientSelect = (event) => {
    const client = customers.find((c) => c.id === event.target.value);
    setCustomer(client);
  };

  const hadleOnSaveClick = () => {
    const emailTracing = {
      customerId: customer.id,
      emailSubject: emailSubject
    };
    saveHandler(emailTracing);
  };

  const saveHandler = async (emailTracking) => {
    const url = baseUrl + "/api/tracking/init";
    backdropContext.toggle();
    SendPostRequest(url, emailTracking, authContext.token, subscriptionsHandler);
  };

  const subscriptionsHandler = (data) => {
    setEmailTrackingUrl(data.url);
    backdropContext.toggle();
  }

  const hadleOnOkClick = (data) => {
    clearStates();
    props.onHide();
  }

  const clearStates = () => {
    setCustomer(null);
    setEmailSubject(null);
    setEmailTrackingUrl(null);
  };

  const closeHandler = () => {
    clearStates();
    props.onHide();
  };
  return (
    <div>
      <Dialog open={props.isVisible} maxWidth="lg">
        <DialogTitle>
          New Trackin Url
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <div>
                <FormControl sx={{ m: 1, minWidth: 500 }}>
                  <InputLabel id="demo-simple-select-label">
                    Customer
                  </InputLabel>
                  <Select
                    disabled={props.isReadOnly}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Language"
                    onChange={handleClientSelect}
                    value={isNull(customer) ? "" : customer.id}
                  >
                    {customers &&
                      customers.map((data) => {
                        return (
                          <MenuItem value={data.id}>
                            {data.companyDisplayName}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </div>

              <div>
                <TextField
                  sx={{ m: 1, minWidth: 500 }}
                  disabled={props.isReadOnly}
                  id="emailSubject"
                  label="Email subject"
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>

              <div>
                <TextField
                  sx={{ m: 1, minWidth: 500 }}
                  disabled={true}
                  id="trackingUrl"
                  label="Trackin Url"
                  value={emailTracingUrl}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            className="cancelButton"
            variant="contained"
            onClick={closeHandler}
          >
            {props.isReadOnly ? "Close" : "Cancel"}
          </Button>
          <Button
            disabled={props.isReadOnly}
            variant="contained"
            onClick={emailTracingUrl ? hadleOnOkClick : hadleOnSaveClick}
          >
            {emailTracingUrl ? "Ok" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const EmailTrackingModal = (props) => {
  const onHide = () => {
    props.closeModalHandler();
  };

  return (
    <Fragment>
      {ReactDOM.createPortal(
        <ModalContent
          isVisible={props.isVisible}
          onHide={onHide}
          customers={props.customers}
          isReadOnly={props.isReadOnly}
        />,
        document.getElementById("modal-root")
      )}
    </Fragment>
  );
};

export default EmailTrackingModal;
